// extracted by mini-css-extract-plugin
export default {"search_container":"Search_search_container__VCqdS","noposts":"Search_noposts__XstCx"};